import React, { useEffect, useRef, useState } from 'react';
import { useInterval } from 'react-use';
import { CircularProgressbarWithChildren } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import './GoalProgress.scss';
const _getPercentageProgress = (value, goal) => {
  return value < goal ? value * 100 / goal : 100;
};
const _getColorAndDescription = percentage => {
  let description = 'Keep selling!';
  let colorProgress = '#FFC600';
  if (percentage === 0) {
    description = 'No sales yet';
    colorProgress = '#FF3D50';
  }
  if (percentage > 40) {
    description = 'Halfway there!';
    colorProgress = '#5ACB30';
  }
  if (percentage > 70) {
    description = 'Almost there!';
    colorProgress = '#5ACB30';
  }
  if (percentage >= 100) {
    description = 'Congratulations!';
    colorProgress = '#5ACB30';
  }
  return {
    description,
    colorProgress
  };
};
export default function Goal({
  goal,
  sales,
  goal_description,
  body_font_family,
  body_color,
  playing
}) {
  const percentage = _getPercentageProgress(sales, goal);
  const oldValue = useRef(0);
  const [value, setValue] = useState(oldValue.current);
  useInterval(() => {
    playing && setValue(val => {
      if (val >= percentage) {
        oldValue.current = percentage;
        return val;
      }
      return val + 1;
    });
  }, value < percentage ? 50 : null);
  const {
    description,
    colorProgress
  } = _getColorAndDescription(value);
  useEffect(() => {
    if (!playing) setValue(0);
  }, [playing]);
  return /*#__PURE__*/React.createElement("div", {
    className: "goal-progress-container",
    style: {
      fontFamily: body_font_family,
      color: body_color
    }
  }, /*#__PURE__*/React.createElement(CircularProgressbarWithChildren, {
    strokeWidth: 10,
    value: value || 1,
    styles: {
      // Customize the root svg element
      root: {
        maxHeight: 534
      },
      // Customize the path, i.e. the "completed progress"
      path: {
        // Path color
        stroke: colorProgress,
        // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
        strokeLinecap: 'round',
        // Customize transition animation
        transition: 'stroke-dashoffset 0s ease 0s',
        // Rotate the path
        transformOrigin: 'center center'
      },
      // Customize the circle behind the path, i.e. the "total progress"
      trail: {
        // Trail color
        stroke: '#969696',
        // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
        strokeLinecap: 'round',
        // Rotate the trail
        transform: 'rotate(0.25turn)',
        transformOrigin: 'center center'
      },
      // Customize the text
      text: {
        // Text color
        fill: 'blue',
        // Text size
        fontSize: '21px',
        fontWeight: 'bold'
      },
      // Customize background - only used when the `background` prop is true
      background: {
        fill: '#969696'
      }
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "description-progress"
  }, description), /*#__PURE__*/React.createElement("div", {
    className: "percentage-progress"
  }, /*#__PURE__*/React.createElement("div", null, value), /*#__PURE__*/React.createElement("div", {
    className: "percentage-symbol"
  }, "%")), /*#__PURE__*/React.createElement("div", {
    className: "goal-description"
  }, `${goal_description} ${value === 100 ? 'REACHED!' : ''}`)));
}